import store from 'Store'

export class Notification {
  constructor(type = 'error', icon = true, timeout = 2500, message = '') {
    this.type = type
    this.icon = icon
    this.timeout = timeout
    this.message = message
  }
  dispatch() {
    store.dispatch('notifications/add', this)
  }
}
